(() => {
  const config = JSON.parse(document.getElementById('kip-runtime').textContent);
  const labels = config.labels;
  const bag = document.getElementById('kip-bag');
  const menu = document.getElementById('kip-menu');
  let returnFocus;
  let cartBusy = false;
  const openDialog = (dialog) => {
    returnFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('dialog-open');
  };
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('dialog-open');
      returnFocus?.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  });
  document.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
  document.querySelector('[data-open-menu]')?.addEventListener('click', () => openDialog(menu));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.close()));

  const refreshCart = async () => {
    const response = await fetch(`${config.cart}?section_id=ripple-cart`, {headers: {Accept: 'text/html'}, cache: 'no-store'});
    if (!response.ok) throw new Error(labels.add_error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fragment = html.querySelector('[data-cart-fragment]');
    if (!fragment) throw new Error(labels.add_error);
    const count = [...fragment.querySelectorAll('[name="updates[]"]')].reduce((sum, input) => sum + Number(input.value), 0);
    document.querySelectorAll('[data-bag-count]').forEach(el => { el.textContent = String(count); });
    bag.querySelector('[data-bag-content]').replaceChildren(fragment);
    const pageCart = document.querySelector('main [data-cart-fragment]');
    if (pageCart) pageCart.replaceWith(fragment.cloneNode(true));
  };
  document.querySelector('[data-open-bag]')?.addEventListener('click', async event => {
    event.preventDefault();
    openDialog(bag);
    const error = bag.querySelector('[data-bag-error]');
    error.textContent = '';
    try { await refreshCart(); } catch { error.textContent = labels.add_error; }
  });
  const changeQuantity = async (line, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    const checkoutButtons = [...document.querySelectorAll('.native-cart-form button')];
    checkoutButtons.forEach(button => { button.disabled = true; });
    const error = bag.open ? bag.querySelector('[data-bag-error]') : document.querySelector('[data-cart-error]');
    if (error) error.textContent = '';
    line.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${config.change}.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: line.dataset.key, quantity})
      });
      if (!response.ok) throw new Error(labels.add_error);
      await refreshCart();
    } catch {
      if (error) error.textContent = labels.add_error;
      else location.reload();
    } finally {
      cartBusy = false;
      checkoutButtons.forEach(button => { button.disabled = false; });
      line.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-quantity-step]');
    const remove = event.target.closest('[data-remove-line]');
    if (!step && !remove) return;
    event.preventDefault();
    const line = (step || remove).closest('[data-cart-line]');
    const input = line.querySelector('[name="updates[]"]');
    const quantity = remove ? 0 : Math.max(0, Math.min(99, Number(input.value) + Number(step.dataset.quantityStep)));
    void changeQuantity(line, quantity);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[name="updates[]"]')) {
      void changeQuantity(event.target.closest('[data-cart-line]'), Math.max(0, Math.min(99, Number(event.target.value) || 0)));
    }
  });
  document.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
    const picker = button.closest('.format-picker');
    picker.querySelectorAll('[data-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    picker.querySelectorAll('[data-format-kind]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.formatKind !== button.dataset.filter; });
    const status = picker.querySelector('[role="status"]');
    if (status) status.textContent = '';
  }));

  const gallery = document.querySelector('[data-gallery]');
  let format = gallery?.dataset.initialFormat || 'single';
  let imageIndex = 0;
  const galleryItems = () => [format, ...(format === 'nightly' ? ['kit'] : []), 'evening', 'founder'];
  const imageLabel = key => key === 'kit' ? labels.first_box : key === 'founder' ? labels.tin : labels[key];
  const drawGallery = () => {
    if (!gallery) return;
    const keys = galleryItems();
    imageIndex = Math.max(0, Math.min(imageIndex, keys.length - 1));
    const key = keys[imageIndex];
    const image = gallery.querySelector('[data-gallery-image]');
    image.src = config.images[key];
    image.alt = imageLabel(key);
    gallery.querySelector('[data-image-count]').textContent = `${imageIndex + 1} / ${keys.length} · ${imageLabel(key)}`;
    const thumbnails = keys.map((key, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `${labels.show_image} ${index + 1}: ${imageLabel(key)}`);
      button.setAttribute('aria-pressed', String(imageIndex === index));
      const thumb = document.createElement('img');
      thumb.src = config.images[key].replace('-1200.webp', '-400.webp');
      thumb.alt = imageLabel(key);
      thumb.width = 82;
      thumb.height = 86;
      button.append(thumb);
      button.addEventListener('click', () => { imageIndex = index; drawGallery(); });
      return button;
    });
    gallery.querySelector('[data-thumbnails]').replaceChildren(...thumbnails);
  };
  gallery?.querySelector('[data-previous-image]').addEventListener('click', () => { imageIndex = (imageIndex + galleryItems().length - 1) % galleryItems().length; drawGallery(); });
  gallery?.querySelector('[data-next-image]').addEventListener('click', () => { imageIndex = (imageIndex + 1) % galleryItems().length; drawGallery(); });
  gallery?.querySelector('[data-zoom]').addEventListener('click', () => {
    const dialog = gallery.querySelector('dialog');
    const image = dialog.querySelector('img');
    image.src = config.images[galleryItems()[imageIndex]].replace('-1200.webp', '-1600.webp');
    image.alt = imageLabel(galleryItems()[imageIndex]);
    openDialog(dialog);
  });
  drawGallery();

  const form = document.querySelector('.native-product-form');
  if (form) {
    const choices = [...form.querySelectorAll('[data-format]')];
    const button = form.querySelector('[name="add"]');
    const update = () => {
      const choice = choices.find(input => input.checked);
      if (!choice) { button.disabled = true; return; }
      const recurring = choice.value === 'nightly';
      format = choice.value;
      imageIndex = 0;
      drawGallery();
      choices.forEach(input => input.closest('label').classList.toggle('is-selected', input.checked));
      form.querySelector('[name="id"]').value = choice.dataset.variant;
      const plan = form.querySelector('[name="selling_plan"]');
      plan.value = choice.dataset.plan;
      plan.disabled = !recurring;
      form.querySelector('[data-founding-note]').hidden = !recurring;
      form.querySelector('[data-selected-image]').src = config.images[format].replace('-1200.webp', '-400.webp');
      form.querySelector('[data-selected-title]').textContent = labels[format];
      form.querySelector('[data-selected-detail]').textContent = labels[`${format}_detail`];
      form.querySelector('[data-selected-cadence]').textContent = recurring ? labels.every_four_weeks : labels.one_time;
      form.querySelector('[data-selected-per]').textContent = choice.dataset.per;
      form.querySelector('[data-selected-per-label]').textContent = recurring ? labels.renewal_pouch : labels.per_pouch;
      form.querySelector('[data-selected-price]').textContent = choice.dataset.priceFormatted;
      form.querySelector('[data-price-cadence]').textContent = recurring ? labels.every_four_weeks : labels.one_time;
      form.querySelector('[data-price-quantity]').textContent = labels[`${format}_quantity`];
      button.disabled = choice.disabled || !choice.dataset.variant || (recurring && !choice.dataset.plan);
      form.querySelector('[data-add-label]').textContent = button.disabled ? labels.sold_out : `${labels.preorder} · ${choice.dataset.priceFormatted}`;
    };
    choices.forEach(input => input.addEventListener('change', update));
    update();
    form.querySelector('[data-format-fieldset]').disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      const error = form.querySelector('[data-product-error]');
      error.textContent = '';
      form.querySelector('[data-add-label]').textContent = labels.adding;
      const data = new FormData(form);
      data.delete('kip_format');
      try {
        const response = await fetch(`${config.add}.js`, {method: 'POST', headers: {Accept: 'application/json'}, body: data});
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || labels.add_error);
        }
        await refreshCart();
        openDialog(bag);
      } catch (problem) {
        error.textContent = problem.message || labels.add_error;
      } finally { update(); }
    });
  }
  document.querySelectorAll('[data-product-film]').forEach(frame => {
    const video = frame.querySelector('video');
    if (!video) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    video.controls = false;
    const update = () => {
      frame.dataset.playing = String(!video.paused);
    };
    const play = () => { void video.play().catch(update); };
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView && !motion.matches && !document.hidden) play(); else video.pause();
    }, {threshold: 0.2}).observe(frame);
    motion.addEventListener('change', () => { if (motion.matches) video.pause(); else if (inView && !document.hidden) play(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (inView && !motion.matches) play(); });
  });
})();
